import React from 'react';
import { useLocation } from 'react-router-dom';
import { CompanyName, MainTitle } from '../../utils/Constants';
// Images
import FlowerBanner from '../../assets/images/temp/flower-banner-background.svg';

function ContentWithImagesComponent({
  children,
  imageOne,
  imageTwo,
  imageThree,
  imageFour,
  imageFive,
}) {
  // Convert children to an array
  const location = useLocation();

  const contentArray = React.Children.toArray(children);
  const images = [imageOne, imageTwo, imageThree, imageFour];

  const useMiddleImage = location.pathname.includes('about') ? true : false;

  return (
    <section className='lg:container grid lg:mx-auto bg-colour5 w-full shadow-cardShadowBold'>
      <div className='grid lg:grid-cols-[2fr_1fr] gap-6'>
        {/* Desktop Layout: Content on Left, Images on Right */}
        <article className='hidden lg:block my-8 pl-16 xl:pl-16'>
          {children}
        </article>

        {/* Desktop Images */}
        <section className='hidden lg:grid flex-col justify-center items-center space-y-8 p-16 -ml-10'>
          <img
            src={imageOne}
            alt={`${CompanyName} ${MainTitle}`}
            className=' rounded-lg shadow-cardShadowBold shadow-colour4/80 md:max-h-[70vh]'
          />

          {/* Just for lg screen */}
          {useMiddleImage && (
            <img
              src={imageFive}
              alt={`${CompanyName} ${MainTitle}`}
              className='w-full xl:hidden max-w-md rounded-lg shadow-cardShadowBold shadow-colour4/80 md:max-h-[70vh]'
            />
          )}

          <img
            src={imageTwo}
            alt={`${CompanyName} ${MainTitle}`}
            className=' rounded-lg shadow-cardShadowBold shadow-colour4/80 md:max-h-[70vh]'
          />
        </section>
      </div>

      {/* Mobile Layout: Alternate text and images */}
      <div className='lg:hidden flex flex-col gap-6 w-full mb-10'>
        {contentArray.map((textBlock, index) => (
          <div key={index} className='flex flex-col items-center w-full'>
            <article className='px-6 my-4 text-center w-full'>
              {textBlock}
            </article>
            {images[index] && (
              <div
                style={{
                  backgroundImage: `url(${FlowerBanner})`,
                  backgroundSize: 'contain',
                  backgroundPosition: 'center',
                  backgroundRepeat: 'no-repeat',
                }}
                className='px-12 w-full'
              >
                <img
                  src={images[index]}
                  alt={`${CompanyName} ${MainTitle} xx`}
                  className=' rounded-lg shadow-cardShadowBold shadow-colour4/80 sm:max-h-[70vh] mx-auto'
                />
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
}

export default ContentWithImagesComponent;
